import { z } from "zod";

export const PROVIDER_MODES = ["SANDBOX", "LIVE"] as const;
export type ProviderMode = (typeof PROVIDER_MODES)[number];
export type ProviderModeFilter = "" | ProviderMode;
export type ProviderActiveFilter = "" | "true" | "false";

const timeout = z.string()
  .regex(/^\d+$/, "100~60,000 사이의 정수를 입력해 주세요.")
  .refine((value) => Number(value) >= 100 && Number(value) <= 60_000, "100~60,000 사이로 입력해 주세요.");
const optionalPath = z.string().trim().max(500, "경로는 500자 이하로 입력해 주세요.")
  .refine((value) => value === "" || value.startsWith("/"), "경로는 /로 시작해 주세요.");

export const providerConfigurationFormSchema = z.object({
  providerCode: z.string().trim().min(1, "연동사를 선택하거나 공급자 코드를 입력해 주세요.").max(40, "공급자 코드는 40자 이하로 입력해 주세요."),
  serviceType: z.string().trim().min(1, "서비스를 선택하거나 서비스 코드를 입력해 주세요.").max(40, "서비스 코드는 40자 이하로 입력해 주세요."),
  mode: z.enum(PROVIDER_MODES),
  configurationName: z.string().trim().min(1, "설정명을 입력해 주세요.").max(100, "설정명은 100자 이하로 입력해 주세요."),
  baseUrl: z.string().trim().max(1000, "Base URL은 1,000자 이하로 입력해 주세요."),
  callbackPath: optionalPath,
  returnPath: optionalPath,
  connectTimeoutMs: timeout,
  readTimeoutMs: timeout,
  metadataText: z.string(),
});
export type ProviderConfigurationFormValues = z.infer<typeof providerConfigurationFormSchema>;

export const providerCredentialFormSchema = z.object({
  credentialName: z.string().trim().min(1, "인증 항목을 선택하거나 코드를 입력해 주세요.").max(80, "인증 항목 코드는 80자 이하로 입력해 주세요."),
  credentialValue: z.string().min(1, "새 인증값을 입력해 주세요.").max(4000, "인증값은 4,000자 이하로 입력해 주세요."),
  reauthenticationPassword: z.string().min(1, "현재 관리자 비밀번호를 입력해 주세요.").max(200, "비밀번호는 200자 이하로 입력해 주세요."),
});
export type ProviderCredentialFormValues = z.infer<typeof providerCredentialFormSchema>;

export function parseProviderMode(value: string | null): ProviderModeFilter {
  return PROVIDER_MODES.includes(value as ProviderMode) ? value as ProviderMode : "";
}
export function parseProviderActive(value: string | null): ProviderActiveFilter {
  return value === "true" || value === "false" ? value : "";
}
export function parseProviderPage(value: string | null): number {
  if (!value || !/^\d+$/.test(value)) return 0;
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) && parsed >= 0 ? parsed : 0;
}
export function parseConfigurationId(value: string | null): number | undefined {
  if (!value || !/^\d+$/.test(value)) return undefined;
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : undefined;
}
